export type AuthorizeNetMerchantAuthentication = {
  name: string | undefined;
  transactionKey: string | undefined;
};

export type SmartPayConfiguration = {
  customerId: string | undefined;
  customerName: string | undefined;
  locationId: string | undefined;
  userName: string | undefined;
  password: string | undefined;
  apiKey: string | undefined;
  secret: string | undefined;
};

const authorizeNetMerchantAuthentications: Record<string, AuthorizeNetMerchantAuthentication> = {
  "01": {
    name: process.env.REACT_APP_MERCHANT_NAME_ATLANTIC,
    transactionKey: process.env.REACT_APP_TRANSACTION_KEY_ATLANTIC,
  },
  "03": {
    name: process.env.REACT_APP_MERCHANT_NAME_BURLINGTON,
    transactionKey: process.env.REACT_APP_TRANSACTION_KEY_BURLINGTON,
  },
  "04": {
    name: process.env.REACT_APP_MERCHANT_NAME_CAMDEN,
    transactionKey: process.env.REACT_APP_TRANSACTION_KEY_CAMDEN,
  },
};

const smartPayConfigurations: Record<string, SmartPayConfiguration> = {
  "03": { /* TODO: remove this when Middlesex MODIV is ready */
    customerId: process.env.REACT_APP_CC_CUSTOMER_ID_MIDDLESEX,
    customerName: process.env.REACT_APP_CC_CUSTOMER_NAME_MIDDLESEX,
    locationId: process.env.REACT_APP_CC_LOCATION_ID_MIDDLESEX,
    userName: process.env.REACT_APP_CC_USER_NAME_MIDDLESEX,
    password: process.env.REACT_APP_CC_PASSWORD_MIDDLESEX,
    apiKey: process.env.REACT_APP_CC_API_KEY_MIDDLESEX,
    secret: process.env.REACT_APP_CC_SECRET_MIDDLESEX,
  },
  "12": {
    customerId: process.env.REACT_APP_CC_CUSTOMER_ID_MIDDLESEX,
    customerName: process.env.REACT_APP_CC_CUSTOMER_NAME_MIDDLESEX,
    locationId: process.env.REACT_APP_CC_LOCATION_ID_MIDDLESEX,
    userName: process.env.REACT_APP_CC_USER_NAME_MIDDLESEX,
    password: process.env.REACT_APP_CC_PASSWORD_MIDDLESEX,
    apiKey: process.env.REACT_APP_CC_API_KEY_MIDDLESEX,
    secret: process.env.REACT_APP_CC_SECRET_MIDDLESEX,
  },
};

const chargeAuthorizationURLs: Record<string, string | undefined> = {
  "01": process.env.REACT_APP_CC_CHARGE_URL_ATLANTIC,
  "03": process.env.REACT_APP_CC_CHARGE_URL_BURLINGTON,
  "04": process.env.REACT_APP_CC_CHARGE_URL_CAMDEN,
  "12": process.env.REACT_APP_CC_CHARGE_URL_MIDDLESEX,
};

const paymentProcessors: Record<string, string | undefined> = {
  "01": process.env.REACT_APP_CC_PROCESSOR_ATLANTIC,
  //"03": process.env.REACT_APP_CC_PROCESSOR_BURLINGTON,
  "03": process.env.REACT_APP_CC_PROCESSOR_MIDDLESEX,
  "04": process.env.REACT_APP_CC_PROCESSOR_CAMDEN,
  "12": process.env.REACT_APP_CC_PROCESSOR_MIDDLESEX,
};

export const getMerchantAuthentication = (countyKey: string): AuthorizeNetMerchantAuthentication | undefined =>
  authorizeNetMerchantAuthentications[countyKey];

export const getChargeAuthorizationURL = (countyKey: string): string | undefined =>
  chargeAuthorizationURLs[countyKey];

export const getPaymentProcessor = (countyKey: string): string | undefined =>
  paymentProcessors[countyKey];

export const getSmartPayConfiguration = (countyKey: string): SmartPayConfiguration | undefined =>
  smartPayConfigurations[countyKey];
